@import '../../scss/mixin';

.root {
  :global(.llm__row) {
    padding: 0 0 1rem 0;
  }
}

.image {
  width: 100%;
  max-width: 256px;
  aspect-ratio: 1;
  border-radius: 8px;
  border: var(--llm-markdown-border);
  box-shadow: shadow(xs);
}
